import CoursePackageForm from "./CoursePackageForm";
export default function AddCoursePackage() {
  return <CoursePackageForm mode="add" />;
}